import { Executive } from 'Types/PersonTypes';
import { backgroundColorParsing } from 'Utils/UtilityFunctions';

export type PersonCardSimpleSource = Pick<
Executive,
| 'personId'
| 'personName'
| 'personImage'
| 'personDesignation'
| 'headline'
| 'companyName'
| 'companyId'
| 'personAdded'
| 'archeType'
| 'personalityTypes'
> & {
  personType?: string;
  executiveType?: string;
  location?: string;
};

export type PersonCardSimpleOptions = {
  invertFollow?: boolean;
  inGlobalSearch?: boolean;
  isGuestUser?: boolean;
  isSearchPage?: boolean;
  disableNavigation?: boolean;
  openInNewTab?: boolean;
  peopleIFollow?: boolean;
  companyStaff?: boolean;
  follow?: boolean;
  noFollow?: boolean;
};

export type PersonListRowProps = {
  personId: number;
  personName: string;
  personImage: string;
  personDesignation: string;
  headline: string;
  companyName: string;
  companyId: number;
  location?: string;
  archetypeColor: string;
  personalityColor: string;
  personAdded: boolean;
  personType?: string;
  executiveType?: string;
  follow?: boolean;
  noFollow?: boolean;
  disableNavigation?: boolean;
  openInNewTab?: boolean;
  isSearchPage?: boolean;
  isLivePerson?: boolean;
};

const getFollowLabel = (
  executive: PersonCardSimpleSource,
  options: PersonCardSimpleOptions,
) => {
  if (typeof options.follow === 'boolean') {
    return options.follow;
  }
  if (options.peopleIFollow) {
    return false;
  }
  if (options.companyStaff) {
    return !executive.personAdded;
  }
  if (options.invertFollow) {
    return !executive.personAdded;
  }
  return executive.personAdded;
};

export const mapExecutiveToPersonCardSimple = (
  executive: PersonCardSimpleSource,
  options: PersonCardSimpleOptions = {},
): PersonListRowProps => {
  const personType = executive.personType ?? executive.executiveType ?? 'EXECUTIVE';

  return {
    personId: executive.personId,
    personName: executive.personName ?? '',
    personImage: executive.personImage ?? '',
    personDesignation: executive.personDesignation ?? '',
    headline: executive.headline ?? '',
    companyName: executive.companyName ?? '',
    companyId: executive.companyId ?? 0,
    location: executive.location ?? '',
    archetypeColor: executive.archeType?.color ?? '#979797',
    personalityColor: backgroundColorParsing(executive.personalityTypes),
    personAdded: executive.personAdded,
    personType,
    executiveType: executive.executiveType ?? 'EXECUTIVE',
    follow: getFollowLabel(executive, options),
    noFollow: options.noFollow ?? options.isGuestUser ?? false,
    disableNavigation: options.disableNavigation ?? false,
    openInNewTab: options.openInNewTab ?? false,
    isSearchPage: options.isSearchPage ?? false,
    isLivePerson: personType === 'LIVESEARCH',
  };
};
